import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from "react-redux";
import CheckbookTray from '../components/CheckBook/CheckbookTray'
import Dashboard from '../components/Menu/Dashboard';
import { withRouter } from 'react-router-dom'
import { getCheckbook } from './../actions/checkbook-emited'

class CheckbookChargeContainer extends Component {
    state = {
        title: 'Acciones',
        subTitle: 'Como desea cobrar el cheque?',
        openDialog: false,
        openDialogOTP: false,
        openDialogPrompt: false,
        amount: 0,
        selectedDate: '',
        description: '',
        emitidor: {},
        otp: 0,
        request: '',
        message: '',
        typeText: 'text',
        type: 'info',
        checkbooks: [] };
    componentDidMount() {
        return (this.props.checkbookEmited.length === 0) ? this.fetchCheckbooks(this.props.user.vusk, this.props.PaymentType) :
        this.setState({
            checkbooks: this.props.checkbookEmited
        })
    }
    
    fetchCheckbooks = (cedule, PaymentType) => {
        cedule && this.props.getCheckbook(PaymentType, cedule).then(({payload})=> {
            payload &&
            this.setState({
                checkbooks: payload
            })
        })
    }

    createButton = (name) => {
        return { name }
    }

    handleOpenDialog = (data) => {
        return (data.state === '0') && this.setState({ openDialog: true, 
            amount: data.amount, request: data.request, otp: data.otp,
            selectedDate: data.date, emitidor: data.Emitidor, description: data.description })
    }

    handleOpenDialogOTP = () => {
      this.setState({ openDialogOTP: true })
    }
    
    handleCloseDialog = () => {
      this.setState({ openDialog: false });
    };

    handleCloseDialogOTP = () => {
      this.setState({ openDialogOTP: false });
    };

    handleCloseDialogPrompt = () => {
      this.setState({ openDialogPrompt: false });
    };
    
    handleSubmit = (values) => {
        this.setState({ alert: true })
    }



    receivePrompt = (description) => {
    }

    
    renderBody = () => {
        return <div>
                    <CheckbookTray
                        {...this.props}
                        classes = { this.props }
                        typeRequest = 'Charge'
                        paymentsData = { this.state.checkbooks }
                        handleOpenDialog= { this.handleOpenDialog }
                        // handleSubmit={ this.handleSubmit }
                    />
                </div>
    }
    render() {
        const { title } = this.props
        // const { alert } = this.state
        return (
            <div>
                <Dashboard
                    title= { title }
                    body = { this.renderBody() }
                    multiple = { false }
                />
            </div>
        )
    }
}


CheckbookChargeContainer.propTypes = {
    user: PropTypes.object.isRequired,
    PaymentType: PropTypes.string.isRequired,
    checkbookEmited: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    devices: PropTypes.object.isRequired,
}


export default withRouter(connect(null, {
    getCheckbook
} )(CheckbookChargeContainer));
// export default CheckbookChargeContainer